import {TextArea, TextBox} from "devextreme-react";
import React from "react";
import {Controller, useFormContext, useFormState} from "react-hook-form";

interface IProps {
    title?: string;
    fieldName: string;
    required?: boolean;
    showBorder?: boolean;
}

export const NFTextAreaInput = ({title, fieldName, required, showBorder = true}: IProps) => {
    const {register, control} = useFormContext();
    const {errors, dirtyFields} = useFormState();

    return (
        <Controller control={control} name={fieldName} rules={{
            required: required === true,
            onChange: (newValue: string) => {
                // console.log(newValue);
            }
        }} render={({field: {onChange, onBlur, value, ref}}) => (
            <div className={title ? "form-group" : ""}>
                {title && <label className={"form-label-sm"}>{title}</label>}
                <TextArea value={value} onValueChanged={(e) => onChange(e.value)}
                          style={{border: (showBorder === true ? "block" : "none")}}
                          validationStatus={errors[fieldName] ? "invalid" : dirtyFields[fieldName] ? "valid" : "valid"}/>
            </div>)}/>
    )
}